import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Container } from 'react-bootstrap';
import { LandscapeIndicatorContributionOrganism } from '../../organisms';
import { VerificationStatusResponseDto } from '../../../store/landscapeAPI/verificationStatus/dto/response/verification-status-response.dto';
import { ValueResponseDto } from '../../../store/landscapeAPI/value/dto/response/value-response.dto';
import LandscapeIndicatorBaseTemplate from '../../../templates/LandscapeIndicatorBaseTemplate';
import styles from './LandscapeIndicatorTargetTemplate.module.css';

interface LandscapeIndicatorTargetTemplateProps {
  verificationStatuses: VerificationStatusResponseDto[];
  target: ValueResponseDto;
  handleOnChange: (contribution: ValueResponseDto) => void;
  callbackFn: (contribution: ValueResponseDto) => void;
}

const LandscapeIndicatorTargetTemplate: FC<
  LandscapeIndicatorTargetTemplateProps
> = ({ verificationStatuses, target, handleOnChange, callbackFn }) => {
  return (
    <BaseTemplate>
      <Container>
        <LandscapeIndicatorBaseTemplate>
          <div className={styles.organismWrapper}>
            <LandscapeIndicatorContributionOrganism
              verificationStatuses={verificationStatuses}
              data={target}
              handleOnChange={handleOnChange}
              callbackFn={callbackFn}
            />
          </div>
        </LandscapeIndicatorBaseTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeIndicatorTargetTemplate;
